
import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { SharedService } from 'src/app/services/shared.service';

enum Step {
  LOADING = 'LOADING',
  VERIFIED = 'VERIFIED',
  ERROR = 'ERROR'
}

@Component({
    selector: 'app-emial-verification',
    imports: [FormsModule, RouterLink],
    templateUrl: './emial-verification.component.html',
    styleUrl: './emial-verification.component.scss'
})
export class EmialVerificationComponent implements OnInit, OnDestroy {
  loaderTimeout: any;
  readonly doctorInfo = signal<any>(undefined);
  doctor_id: any;
  step = Step;
  readonly selectedStep = signal<Step>(Step.LOADING);
  userProfile: any;
  readonly mask = signal<string>('');
  loaderComplete: boolean = false;
  public country_data: any;
  countrySub!: Subscription;
  private paramMapSub!: Subscription;
  currency_data: any;

  constructor(
    private route: ActivatedRoute,
    private _api: ApiService,
    public _shared: SharedService,
    private _local: localStorageService,
  ) { }

  ngOnInit() {
    this.mask.set('(000) 000-0000');
    this.userProfile = this._local.customGetItem('userProfileData');
    this.paramMapSub = this.route.paramMap.subscribe(params => {
      this.doctor_id = params.get('id') || '';

      if (this.doctor_id) {
        // this.getInfo();
        this.sendVerifyEmailLink();
      }
    });

    this.countrySub = this._shared.country_currency_info$.subscribe(data => {
      if (data?.country) {
        this.country_data = data.country;
        this.mask.set(data.country.country_phone_format || '');
      }
      if (data?.currency?.length) {
        this.currency_data = data.currency[0];
      }
    });

  }

  sendVerifyEmailLink() {
    const payload = {
      token: this.doctor_id
    };

    this._api.api(payload, 'auth/send_verify_link_email').subscribe({

      next: (response: any) => {
        if (response && !response.is_error) {
          console.log('Verification email sent successfully');
          this.selectedStep.set(this.step.LOADING);
          this.startLoader()
        }else {
          this.stopLoader()
        this.selectedStep.set(this.step.ERROR); 
      }
      },
      error: () => {
        console.error('Failed to send verification email');
         this.selectedStep.set(this.step.ERROR);
      }
    });
  }

// getInfo(){
//   const payload = {
//       token: this.doctor_id
//     };

//   this._api.api( payload ,'auth/doctor_info', 'get').subscribe({
//   next: (response: any) => {
//     if (response && !response.is_error) {
//       this.doctorInfo.set(response.doctorInfo[0]);
//       console.log(this.doctorInfo);
//     }
//   },
//   error: (err) => console.error(err)
// });

// }


  startLoader() {
   this.loaderTimeout = setTimeout(() => {
      this.selectedStep.set(this.step.VERIFIED);
    }, 4000);
  }

  stopLoader() {
  if (this.loaderTimeout) {
    clearTimeout(this.loaderTimeout);
    this.loaderTimeout = null;
  }
}

  ngOnDestroy(): void {
    this.stopLoader();
    this.countrySub?.unsubscribe();
    this.paramMapSub?.unsubscribe();
  }

}
